module.exports = __webpack_public_path__ + "static/media/TYPH-BNB.51b23463.png";